import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import { makeProvider } from '../../helpers/makeContexts';

const editDashChartsInit = {
  dashboardCharts: {},
  selectedDashChartId: null,
  currentDraggedChartId: null,
  chartDashboardDataTables: {},
  widgetCustomJoins: {},
  maxWidgets: 15,
};

function editDashChartsReducer(draft, { type, payload }) {
  switch (type) {
    case 'setDashboardCharts': {
      let tmpdashcharts = {};
      // if from backend
      if (payload && Array.isArray(payload)) {
        payload.forEach((chart) => {
          if (chart && chart.id != null) {
            tmpdashcharts[chart.id] = chart;
          }
        });
        draft.dashboardCharts = tmpdashcharts;
      }
      // if already normalized in controller
      else {
        draft.dashboardCharts = payload;
      }
      break;
    }
    case 'setSelectedDashChartId': {
      draft.selectedDashChartId = payload;
      break;
    }
    case 'setCurrentDraggedChartId': {
      draft.currentDraggedChartId = payload;
      break;
    }
    case 'addDashboardCharts': {
      //this is called when a chart is dropped on the dashboard
      // draft.dashboardCharts[`new${payload?.ChartId}`] = payload;
      for (let i = 0; i < payload.DashboardCharts.length; i++) {
        let dashChart = payload?.DashboardCharts[i];
        let chart = payload?.Charts?.length
          ? payload?.Charts.find((chart) => chart.id === dashChart.ChartId)
          : null;

        const newChart = {
          ...chart,
          ChartDashboardDataTables: chart?.ChartDashboardDataTables || [],
          WidgetCustomJoins: chart?.WidgetCustomJoins || [],
        };
        const newDashChart = {
          ...dashChart,
          Chart: newChart,
        };
        dashChart.Chart = chart;
        draft.dashboardCharts[dashChart.id] = newDashChart;
      }
      break;
    }
    case 'resetDashboardCharts': {
      draft.dashboardCharts = {};
      break;
    }
    case 'updateChartinDashChart': {
      let dashchartKey = Object.keys(draft.dashboardCharts).find(
        (key) => draft.dashboardCharts[key].ChartId === payload.id
      );

      if (dashchartKey !== undefined) {
        draft.dashboardCharts[[dashchartKey]].Chart = payload;
      }
      break;
    }
    case 'setChartDashboardDataTables': {
      draft.chartDashboardDataTables = payload;
      break;
    }
    case 'addChartDashboardDataTable': {
      if (!draft.chartDashboardDataTables[payload.chartId]) {
        draft.chartDashboardDataTables[payload.chartId] = {};
      }
      draft.chartDashboardDataTables[payload.chartId][payload.dataTableId] =
        payload.content;
      break;
    }
    case 'removeChartDashboardDataTable': {
      if (
        draft.chartDashboardDataTables[payload.chartId]?.[payload.dataTableId]
      ) {
        delete draft.chartDashboardDataTables[payload.chartId][
          payload.dataTableId
        ];
      }
      break;
    }
    case 'setWidgetCustomJoins': {
      draft.widgetCustomJoins = payload;
      break;
    }
    case 'addWidgetCustomJoin': {
      if (!draft.widgetCustomJoins[payload.chartId]) {
        draft.widgetCustomJoins[payload.chartId] = {};
      }
      draft.widgetCustomJoins[payload.chartId][payload.customJoinId] = true;
      break;
    }
    case 'removeWidgetCustomJoin': {
      if (draft.widgetCustomJoins[payload.chartId]?.[payload.customJoinId]) {
        delete draft.widgetCustomJoins[payload.chartId][payload.customJoinId];
      }
      break;
    }

    case 'updateDashboardCharts': {
      for (let i = 0; i < payload.DashboardCharts.length; i++) {
        const dashChart = payload.DashboardCharts[i];
        draft.dashboardCharts[dashChart.id] = dashChart;
      }
      break;
    }
    case 'deleteDashboardChart': {
      delete draft.dashboardCharts[payload.dashboardChartId];
      break;
    }
    default: {
      return null;
    }
  }
}

const [EditDashChartsContext, EditDashChartsDispatchContext] = [
  createContext(null),
  createContext(null),
];

export const DashboardChartsProvider = makeProvider(
  EditDashChartsContext,
  EditDashChartsDispatchContext,
  editDashChartsReducer,
  editDashChartsInit
);

export function useDashboardChartsStore() {
  return useContext(EditDashChartsContext);
}

export function useDashboardChartsDispatch() {
  return useContext(EditDashChartsDispatchContext);
}
